import React from 'react';
import { Accessibility, MessageSquare, ShieldCheck } from 'lucide-react';
import PolicySectionCard from '@/components/policy/PolicySectionCard';
import PageHeader from '@/components/layout/PageHeader';
import PolicyLayout from '@/components/policy/PolicyLayout';
import { motion } from 'framer-motion';

const AccessibilityStatement = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 }
  };

  return (
    <PolicyLayout>
      <PageHeader
        title="Accessibility Statement"
        description="Last updated: April 11, 2025"
        icon={<Accessibility className="w-8 h-8 text-primary" />}
      />

      {/* Cards Grid */}
      <motion.div 
        className="space-y-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={item}>
          <PolicySectionCard
            title="Our Commitment"
            icon={Accessibility}
            variant="amber"
          >
            <p>Cibeto Technologies Pvt Ltd is committed to ensuring digital accessibility for all users of Edaptica, including individuals with disabilities.</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Accessibility Features"
            icon={ShieldCheck}
            variant="indigo"
          >
            <ul className="list-disc pl-6 space-y-2">
              <li>Keyboard navigability</li>
              <li>Screen reader compatibility</li>
              <li>Alt text for images and visual content</li>
              <li>Clear and consistent layout</li>
            </ul>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Feedback"
            icon={MessageSquare}
            variant="cyan"
          >
            <p>If you experience any accessibility barriers, please let us know at: support@edaptica.com</p>
            <p className="mt-4">We aim to address issues within 7 business days.</p>
          </PolicySectionCard>
        </motion.div>
      </motion.div>
    </PolicyLayout>
  );
};

export default AccessibilityStatement;
